<template>
	<div class="bashboard">
		<NavBar :admin="true" :items="items" />
		<v-main>
			<v-container>
				<template v-if="$store.getters.isSuperAdmin || $store.getters.isMarketing">
					<v-row no-gutters align="center" class="mt-3 mb-3">
						<v-icon color="primary mr-9" class="mr-4">mdi-view-dashboard</v-icon>
						<span class="title font-weight-bold primary--text" v-translate key="general">General</span>
					</v-row>
					<v-divider class="mb-4"></v-divider>
					<v-row no-gutters>
						<TreatmentCard
							v-for="item in generalFiltered"
							:treatment="item"
							:key="item.name"
						/>
					</v-row>
				</template>
				<template v-if="$store.getters.isStaff">
					<v-row no-gutters align="center" class="mt-3 mb-3">
						<v-icon color="primary mr-9" class="mr-4">mdi-clipboard-text</v-icon>
						<span class="title font-weight-bold primary--text" v-translate key="treatments">Treatments</span>
					</v-row>
					<v-divider class="mb-4"></v-divider>
					<v-row no-gutters>
						<TreatmentCard
							v-for="treatment in treatments"
							:treatment="treatment"
							:key="treatment.name"
						/>
					</v-row>
					<v-row no-gutters align="center" class="mt-3 mb-3">
						<v-icon color="primary mr-9" class="mr-4">assessment</v-icon>
						<span class="title font-weight-bold primary--text" v-translate key="tests">Tests</span>
					</v-row>
					<v-divider class="mb-4"></v-divider>
					<v-row no-gutters>
						<TreatmentCard
							v-for="test in tests"
							:treatment="test"
							:key="test.name"
						/>
					</v-row>
				</template>
			</v-container>
		</v-main>
	</div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";
import TreatmentCard from "@/components/settings/TreatmentCard.vue";

export default {
	name: "Dashboard",
	components: {
		NavBar,
		TreatmentCard
	},
	data: () => ({}),
	computed: {
		items() {
			var items = [
				{
					text: this.$gettext("Dashboard"),
					disabled: false,
					link: true,
					to: "/admin/dashboard"
				}
			];
			return items;
		},
		general() {
			return [
				{
					name: this.$gettext("Spaces"),
					to: { name: "spaces" },
					icon: "business",
					permition: this.$store.getters.isSuperAdmin || this.$store.getters.isMarketing
				},
				{
					name: this.$gettext("Payments"),
					to: { name: "payments" },
					icon: "payment",
					permition: this.$store.getters.isSuperAdmin
				},
				{
					name: this.$gettext("Modules"),
					to: { name: "admin-modules" },
					icon: "add_to_queue",
					permition: this.$store.getters.isSuperAdmin
				},
				{
					name: this.$gettext("Planos de Subscrição"),
					to: { name: "subscription-plans" },
					icon: "mdi-format-list-checkbox",
					permition: this.$store.getters.isSuperAdmin
				},
				{
					name: this.$gettext("Discount Codes"),
					to: { name: "discount-codes" },
					icon: "mdi-sale",
					permition: this.$store.getters.isSuperAdmin || this.$store.getters.isMarketing
				},
				{
					name: this.$gettext("Alerts"),
					to: { name: "alerts" },
					icon: "mdi-alert-box",
					permition: this.$store.getters.isSuperAdmin
				},
				{
					name: this.$gettext("Terms and Conditions"),
					to: { name: "terms-conditions" },
					icon: "mdi-information",
					permition: this.$store.getters.isSuperAdmin
				},
				{
					name: this.$gettext("Privacy Policy"),
					to: { name: "privacy-policy" },
					icon: "mdi-information",
					permition: this.$store.getters.isSuperAdmin
				},
				{
					name: this.$gettext("Patient Consent"),
					to: { name: "patient-consent" },
					icon: "mdi-file-document",
					permition: this.$store.getters.isSuperAdmin
				},
				{
					name: this.$gettext("FAQ"),
					to: { name: "question-answers" },
					icon: "mdi-help",
					permition: this.$store.getters.isSuperAdmin
				},
				{
					name: "ICD-11",
					to: { name: "icd-admin", params: {admin: this.admin} },
					icon: "mdi-barcode",
					permition: this.$store.getters.isSuperAdmin
				},
				{
					name: this.$gettext("Drugs"),
					to: { name: "drugs" },
					icon: "mdi-pill",
					permition: this.$store.getters.isSuperAdmin
				},
				{
					name: this.$gettext("Emails"),
					to: { name: "emails" },
					icon: "mdi-email",
					permition: this.$store.getters.isSuperAdmin || this.$store.getters.isMarketing
				},
				{
					name: this.$gettext("Email & SMS"),
					to: { name: "email-sms" },
					icon: "mdi-bell-ring",
					permition: this.$store.getters.isSuperAdmin
				}
			]
		},
		generalFiltered() {
			return this.general.filter(i => i.permition);
		},
		treatments() {
			return [
				{
					name: this.$gettext("Supplements"),
					to: { name: "admin-supplements", params: { admin: this.admin } },
					icon: "mdi-pill",
					code: "sup",
					module: "fito"
				},
				{
					name: this.$gettext("Chinese Materia Medica"),
					to: { name: "admin-cmm", params: { admin: this.admin } },
					icon: "mdi-beaker-outline",
					code: "cmm",
					module: "mtc"
				},
				{
					name: this.$gettext("Acupuncture"),
					to: { name: "admin-acu", params: { admin: this.admin } },
					icon: "mdi-needle",
					code: "acu",
					module: "mtc"
				},
				{
					name: this.$gettext("Product Properties"),
					to: {
						name: "product-properties"
					},
					icon: "mdi-cog-outline"
				},
				{
					name: this.$gettext("Bibliographic References"),
					to: {
						name: "bibliographic-references"
					},
					icon: "mdi-book-open-variant"
				}
			]
		},
		tests() {
			return [
				{
					name: this.$gettext("Osteopathy Settings"),
					to: {
						name: "osteo-settings"
					},
					icon: "mdi-cog-outline"
				},
				{
					name: this.$gettext("Tongue"),
					to: { name: "admin-tongue", params: { admin: this.admin } },
					icon: "$vuetify.icons.tongueRoundN",
					code: "tongue",
					module: "mtc"
				},
				{
					name: "Ryodoraku",
					to: { name: "admin-ryodoraku", params: { admin: this.admin } },
					icon: "mdi-alpha-r-box",
					code: "ryo", 
					module: "mtc"
				},
				{
					name: "Pulso",
					to: { name: "admin-pulse", params: { admin: this.admin } },
					icon: "mdi-pulse",
					code: "pulse",
					module: "mtc"
				}
			]
		}
	}
};
</script>